<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('APPS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.push({ name: 'apps.create' })">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('APPS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <div>
      <v-data-table v-if="apps" :headers="headers" :items="apps">
        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>

        <template v-slot:item.android_version="{ item }">
          <span v-if="item.settings">
            {{ item.settings.android_version }}
            ({{ item.settings.android_build }})
          </span>
        </template>

        <template v-slot:item.ios_version="{ item }">
          <span v-if="item.settings">
            {{ item.settings.ios_version }}
            ({{ item.settings.ios_build }})
          </span>
        </template>

        <template v-slot:item.settings.major="{ item }">
          <v-icon
            v-if="item.settings && item.settings.major"
            color="success"
            class="animate__animated animate__rubberBand"
            v-text="'mdi-check'"
          />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            small
            tile
            depressed
            class="text-none font-weight-regular px-2"
            :to="{ name: 'apps.show', params: { id: item.id } }"
          >
            {{ $t('ITEM.VIEW') }}
          </v-btn>
          <v-btn
            small
            tile
            depressed
            class="text-none font-weight-regular px-2"
            :to="{ name: 'tiles-groups', params: { id: item.id } }"
          >
            {{ $t('TILES.ITEMS') }}
          </v-btn>
          <v-btn
            small
            tile
            depressed
            class="text-none font-weight-regular px-2"
            @click="settingsShow(item)"
          >
            {{ $t('APPS.SETTINGS') }}
          </v-btn>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-if="settingsDialog" v-model="settingsDialog" max-width="400px">
      <app-settings-form v-if="app" :app="app" @updated="settingsUpdated">
        <template v-slot:buttons>
          <v-btn depressed class="mr-2" @click="settingsDialog = false">
            {{ $t('BUTTON.CLOSE') }}
          </v-btn>
        </template>
      </app-settings-form>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AppsPage',

  components: {
    AppSettingsForm: () =>
      import('@/modules/apps/components/AppSettingsForm.vue')
  },

  data: () => ({
    apps: null,
    app: null,
    settingsDialog: false
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('APPS.ANDROID_VERSION_WITH_BUILD'),
          value: 'android_version',
          align: 'center'
        },
        {
          text: this.$t('APPS.IOS_VERSION_WITH_BUILD'),
          value: 'ios_version',
          align: 'center'
        },
        {
          text: this.$t('APPS.MAJOR_UPDATE'),
          value: 'settings.major',
          align: 'center'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'settings.status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'actions',
          align: 'center'
        }
      ];
    }
  },

  created() {
    this.fetchApps();
  },

  methods: {
    fetchApps() {
      this.$store.dispatch('apps/index').then(({ data }) => (this.apps = data));
    },

    settingsShow(app) {
      this.app = app;
      this.settingsDialog = true;
    },

    settingsUpdated() {
      this.$store.commit('snackbar/setSnack', {
        status: 'success',
        text: this.$t('MESSAGE.SUCCESS')
      });

      this.fetchApps();
      this.settingsDialog = false;
    }
  }
};
</script>
